var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Overzicht"}},[_c('main',{staticClass:"relative z-0 flex-1 overflow-y-auto focus:outline-none",attrs:{"tabindex":"0"}},[_c('p',[_vm._v("Hier komen dingen op basis van je organisation_id")])])])}
var staticRenderFns = []

export { render, staticRenderFns }